import React, { useState } from "react";

interface LoginInputProps {
    type: "text" | "password";
    name: string;
    label: string;
    value: string;
    onChange: (value: string) => void;
    autoComplete?: string;
    required?: boolean;
    validationState?: "valid" | "invalid" | null;
    className?: string;
}

const EyeIcon: React.FC = () => (
    <svg width="22" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.09 15c4.823 0 8.574-3.875 10.181-6.125.67-.875.67-2 0-2.875-1.607-2.125-5.358-6-10.18-6C6.268 0 2.518 3.875.91 6.125c-.67.875-.67 2 0 2.75C2.518 11.125 6.268 15 11.09 15zm0-11.25c2.278 0 4.02 1.625 4.02 3.75s-1.742 3.75-4.02 3.75c-2.277 0-4.018-1.625-4.018-3.75s1.741-3.75 4.019-3.75z"
            fill="#D1D1D1"
        />
    </svg>
);

const LoginInput: React.FC<LoginInputProps> = ({
    type,
    name,
    label,
    value,
    onChange,
    autoComplete,
    required,
    validationState,
    className = "",
}) => {
    const [showPassword, setShowPassword] = useState(false);
    const isPassword = type === "password";
    const inputType = isPassword && showPassword ? "text" : type;

    const inputClassName = [
        validationState === "valid" ? "valid" : "",
        validationState === "invalid" ? "invalid" : "",
    ]
        .filter(Boolean)
        .join(" ");

    const wrapperClassName = [
        "pg-input",
        isPassword ? "pg-input-has-eye" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={wrapperClassName}>
            <input
                id={`pg-input-${name}`}
                type={inputType}
                name={name}
                value={value}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
                autoComplete={autoComplete}
                required={required}
                className={inputClassName}
                style={
                    validationState === "valid"
                        ? { backgroundImage: "url(/wp-content/themes/pgm/dist/images/check_circle_green.svg)" }
                        : undefined
                }
            />
            <label htmlFor={`pg-input-${name}`} className="pg-input-label">
                {label}
            </label>
            <div className="pg-input-error text-end" />
            {isPassword && (
                <div
                    className="pg-input-eye"
                    onClick={() => setShowPassword(!showPassword)}
                >
                    <EyeIcon />
                </div>
            )}
        </div>
    );
};

export default LoginInput;
